<template>
  <div class="mini-slide-box">
    <div class="swiper-container mini-swiper mini-advertisement-box">
      <ul class="swiper-wrapper swiper-no-swiping">
        <li class="swiper-slide" @click= "tabToOtherArea(item.href)" v-if= "item.type != 'video'" v-for="(item,index) in courseList" :key="index"><span><img :src="item.image.o" draggable="false" alt="德阳经开科创"></span></li>
      </ul>
      <div class="swiper-pagination swiper-mini-pagination"></div>
    </div>
  </div>
</template>

<script>
import "@/../static/css/swiper-4.4.1.min.css"
import Swiper from '@/../static/js/swiper-4.4.1.min.js'

export default {
  name: 'publicMiniSlide',
  props:{
    'type': [String,Object]
  },
  data () {
    return {
      courseList: [],
      miniSwiper: null
    }
  },
  created() {
    this.getMiniSlider();
  },
  updated() {
    this.initMiniSwiper();
  },
  methods:{
    initMiniSwiper: function() {
      let vSelf = this;
      let len = this.courseList.length;

      this.miniSwiper = new Swiper('.mini-swiper', {
            speed: 1000,
            autoplay: {
              delay: 3000
            },
            loop: len > 1 ? true : false,
            noSwiping: len > 1 ? false : true,
            watchOverflow: true,
            pagination: {
              el: '.swiper-mini-pagination'
            },
          });
    },
    tabToOtherArea: function(URL) {
      if (URL != null) {
        window.location.href = URL;
      }
    },
    getMiniSlider: function() {
      if (this.type == 'courseHome') {
        var test = {
          'code': 'web_curriculum_sys_slideshow'
        };
        this.$client.getMiniSlider(test)
        .then((res) => {
          this.courseList = res.data;
        }).catch((err) => {

        })
      }else if (this.type == 'newsHome') {
        var test = {
          'code': 'web_news_slideshow'
        };
        this.$client.getMiniSlider(test)
        .then((res) => {
          this.courseList = res.data;
        }).catch((err) => {

        })
      }else if (this.type == 'teacherForum') {
        var test = {
          'code': 'web_organ_post_slideshow'
        };
        this.$client.getMiniSlider(test)
        .then((res) => {
          this.courseList = res.data;
        }).catch((err) => {
        
        })
      }else if (this.type == 'newsCenter') {
        var test = {
          'code': 'web_news_slideshow'
        };
        this.$client.getMiniSlider(test)
        .then((res) => {
          this.courseList = res.data;
        }).catch((err) => {
       
        })
      }else if (this.type == 'videoCenter') {
        var test = {
          'code': 'web_course_video_list_slideshow'
        };
        this.$client.getMiniSlider(test)
        .then((res) => {
          this.courseList = res.data;
        }).catch((err) => {
      
        })
      }
    }
  }
}
</script>
<style lang="less" scoped>
  .mini-slide-box {
    height: 360px;
    .mini-advertisement-box {
      height: 100%;
      height: 100%;
      &>ul {
        &>li {
          width: 100%;
          cursor: pointer;
          &>span {
            overflow: hidden;
            display: flex;
            width: 100%;
            height: 100%;
            min-width: 1200px;
            &>img {
              display: block;
              width: 100%;
              flex-grow: 1;
              object-fit: cover;
            }
          }
        }
      }
      .swiper-pagination {
        position: absolute;
        bottom: 0;
        padding-bottom: 30px;
      }
    }
  }
</style>
<style>
    .swiper-pagination-bullet{
      display: inline-block;
      width: 30px;
      height: 2px;
      border-radius: 0;
      opacity: 1;
      background: #fff;
    }

    .swiper-pagination-bullet-active {
      background: #ff7800;
    }
</style>




// WEBPACK FOOTER //
// src/components/common/publicMiniSlide.vue